import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=45cae1b0"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45cae1b0')) {
      api.createRecord('45cae1b0', component.options)
    } else {
      api.reload('45cae1b0', component.options)
    }
    module.hot.accept("./Employee.vue?vue&type=template&id=45cae1b0", function () {
      api.rerender('45cae1b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/Employee.vue"
export default component.exports